/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyWithRelations } from './companyWithRelations';


/**
 * (tsType: NormativeAreaWithRelations, schemaOptions: { includeRelations: true })
 */
export interface NormativeAreaWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    companyId: string;
    /**
     * Nombre del área (ej. Operaciones)
     */
    name: string;
    /**
     * Código de 3 letras que abre el código del documento (OPE, RHU). Único por empresa
     */
    code: string;
    displayOrder?: number;
    active?: boolean;
    company?: CompanyWithRelations;
}

